import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./axiosBaseQuery";

export const AUTH_API_REDUCER_KEY = "authApi";
export const authApi = createApi({
  reducerPath: AUTH_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["auth"],
  endpoints: (builder) => ({
    getSession: builder.query({
      query: () => ({
        url: "api/auth/supplier/session",
      }),
      providesTags: ["auth"],
    }),
    login: builder.mutation({
      query: (body) => {
        return {
          url: "api/auth/supplier/login",
          method: "POST",
          body,
        };
      },
    }),
    logout: builder.mutation({
      query: () => ({
        url: "api/auth/supplier/logout",
        method: "POST",
      }),
      invalidatesTags: ["auth"],
    }),

    signUp: builder.mutation({
      query: ({ token, ...rest }) => ({
        url: `api/suppliers/signup/?token=${token}`,
        method: "POST",
        body: rest,
      }),
      // invalidatesTags: ["auth"],
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useGetSessionQuery,

  useSignUpMutation,
} = authApi;
